let checkExprServer;
let getCondZoomTypeServer;
let getCondChooseListServer;
let getCondSearchListServer;
let getCondsZoomTypesServer;

export function initFunctions(funcs) {
    // TODO: merge getCondZoomType and getCondsZoomTypes
    checkExprServer = funcs.checkExpr;
    getCondZoomTypeServer = funcs.getCondZoomType;
    getCondChooseListServer = funcs.getCondChooseList;
    getCondSearchListServer = funcs.getCondSearchList;
    getCondsZoomTypesServer = funcs.getCondsZoomTypes;
}

export function addNewCond(field, cond) {
    if (
        field.conds[field.conds.length - 1].fieldToShowSelected != 0 && // eslint-disable-line eqeqeq
        field.conds[field.conds.length - 1].fieldToShowSelected !== ''
    ) {
        field.addCond(cond);
    }
}

export function createNewCond(field) {
    return field.createNewCond();
}

export function deleteCond(field, cond) {
    field.deleteCond(cond);
}

export function checkCond(container, cond, idx, handleCallback) {
    checkExprServer(
        container,
        idx === 1 ? cond.firstInput : cond.secondInput,
        cond.id,
        idx,
        handleCallback
    );
}

export function getCondZoomType(field, callback) {
    getCondZoomTypeServer && getCondZoomTypeServer(field, callback);
}

export function getCondChooseList(field, callback, realpos?) {
    getCondChooseListServer(field, callback, realpos);
}

export function getCondSearchList(
    field,
    mode,
    cursorIndex,
    startIndex,
    lastString,
    editValue,
    callback
) {
    getCondSearchListServer(field, mode, cursorIndex, startIndex, lastString, editValue, callback);
}

export function setFieldToShow(cond, value) {
    cond.setFieldToShow(value);
}

export function setOp(cond, op, numOfInputs) {
    cond.setOp(op);
    cond.setNumOfInputs(numOfInputs);
}

export function getCondsZoomTypes(container, callback) {
    getCondsZoomTypesServer(container, callback);
}
